import { useSettings } from '@wu/widget-core';
import { useMediaSessionActionHandlers } from '../../../helpers';
import { usePlayer } from '../PlayerProvider';
import { Embed } from './Embed';
import { EmbedBackground } from './EmbedBackground';
import { FloatingBackground } from './FloatingBackground';
import { Floating } from './floating';

export function Layout() {
  const { layout } = useSettings();
  const { statusCachedTrack } = usePlayer();
  useMediaSessionActionHandlers();

  if (statusCachedTrack === 'pending') return null;

  const LayoutComponent = {
    embed: Embed,
    floating: Floating,
    embedBackground: EmbedBackground,
    floatingBackground: FloatingBackground
  }[layout];

  return <LayoutComponent />;
}
